const SET_FULL_SCREEN = 'bitbyte-gui/mode/SET_FULL_SCREEN';
const SET_PLAYER = 'bitbyte-gui/mode/SET_PLAYER';
const SET_FLOATING_MODE = 'bitbyte-gui/mode/SET_FLOATING_MODE';

const initialState = {
    showBranding: false,
    isFullScreen: false,
    isPlayerOnly: false,
    hasEverEnteredEditor: true,
    isFloatingMode: false
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case SET_FULL_SCREEN:
        return Object.assign({}, state, {
            isFullScreen: action.isFullScreen
        });
    case SET_PLAYER:
        return Object.assign({}, state, {
            isPlayerOnly: action.isPlayerOnly,
            hasEverEnteredEditor: state.hasEverEnteredEditor || !action.isPlayerOnly
        });
    case SET_FLOATING_MODE:
        return Object.assign({}, state, {
            isFloatingMode: action.isFloatingMode
        });
    default:
        return state;
    }
};

const setFullScreen = function (isFullScreen) {
    return {
        type: SET_FULL_SCREEN,
        isFullScreen: isFullScreen
    };
};
const setPlayer = function (isPlayerOnly) {
    return {
        type: SET_PLAYER,
        isPlayerOnly: isPlayerOnly
    };
};

const setFloatingMode = function (isFloatingMode) {
    return {
        type: SET_FLOATING_MODE,
        isFloatingMode
    };
};

export {
    reducer as default,
    initialState as modeInitialState,
    setFullScreen,
    setPlayer,
    setFloatingMode
};
